import React from 'react'
import { Link } from 'react-router-dom'
import Seo from '../../components/Seo/Seo'
import Footer from '../../components/Footer/Footer'
import { SEO } from '../../constants/seo'
import './NotFound.css'

const NotFound = () => {
  return (
    <div className="not-found">
      <Seo title={SEO.notFound.title} description={SEO.notFound.description} noIndex />
      <div className="not-found__inner">
        <p className="not-found__code">404</p>
        <h1 className="not-found__title">Page not found</h1>
        <p className="not-found__body">
          The link may be broken or the page may have moved. Try the navigation above or return home.
        </p>
        <Link className="not-found__btn" to="/">
          Back to home
        </Link>
      </div>
      <Footer />
    </div>
  )
}

export default NotFound
